/**
 * Nombres de plantilla que el Worker puede inyectar (subset usado en el cliente).
 *
 * Política: el home en todos los países es `WORKER_HOME_TEMPLATE` (cf. `cloudflare-worker-juaperrone/worker.js`
 * → `COUNTRY_TEMPLATE_MAP`). La UI en la home comparte `BaseTemplateBlack` (variante oscura).
 *
 * `BaseTemplate` y `BaseTemplateBlack` comparten la misma UI en la home (BaseTemplateBlack).
 *
 * `VideoTemplate` también está en la familia: wrappea internamente <BaseTemplate>
 * y agrega video Mux + 2 botones al heroCta. Sin esto, SiteLayout, SobreMi,
 * Audiovisual, Portfolio (que usan `isBaseTemplate` para decidir dark theme)
 * tratan VideoTemplate como light shell → mismatch visual entre nav (light) y
 * contenido (dark).
 */

/** Template de home que inyecta el Worker para cualquier país (mapa + default). */
export const WORKER_HOME_TEMPLATE = "BaseTemplate" as const;

const BASE_TEMPLATE_FAMILY = new Set([
  "BaseTemplate",
  "BaseTemplateBlack",
  "BaseTemplateInternationalDual",
  "BaseTemplateArDual",
  "VideoTemplate",
]);

export function isBaseTemplateFamily(templateName: string | null | undefined): boolean {
  return !!templateName && BASE_TEMPLATE_FAMILY.has(templateName);
}
